import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type IndustryTreeItemFragment = { __typename?: 'Industry', id: string, naics: string, name: string, level: Types.IndustryLevel, parent?: { __typename?: 'Industry', id: string, parent?: { __typename?: 'Industry', id: string } | null } | null };

export type IndustryTreeItemWithChildrenFragment = { __typename?: 'Industry', id: string, naics: string, name: string, level: Types.IndustryLevel, children?: Array<{ __typename?: 'Industry', id: string, naics: string, name: string, level: Types.IndustryLevel, children?: Array<{ __typename?: 'Industry', id: string, naics: string, name: string, level: Types.IndustryLevel, parent?: { __typename?: 'Industry', id: string, parent?: { __typename?: 'Industry', id: string } | null } | null }> | null, parent?: { __typename?: 'Industry', id: string, parent?: { __typename?: 'Industry', id: string } | null } | null }> | null, parent?: { __typename?: 'Industry', id: string, parent?: { __typename?: 'Industry', id: string } | null } | null };

export type IndustryTreeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IndustryTreeQuery = { __typename?: 'Query', industries: { __typename?: 'Industries', tree: Array<{ __typename?: 'Industry', id: string, naics: string, name: string, level: Types.IndustryLevel, children?: Array<{ __typename?: 'Industry', id: string, naics: string, name: string, level: Types.IndustryLevel, children?: Array<{ __typename?: 'Industry', id: string, naics: string, name: string, level: Types.IndustryLevel, parent?: { __typename?: 'Industry', id: string, parent?: { __typename?: 'Industry', id: string } | null } | null }> | null, parent?: { __typename?: 'Industry', id: string, parent?: { __typename?: 'Industry', id: string } | null } | null }> | null, parent?: { __typename?: 'Industry', id: string, parent?: { __typename?: 'Industry', id: string } | null } | null }> } };

export const IndustryTreeItemFragmentDoc = gql`
    fragment IndustryTreeItem on Industry {
  id
  naics
  name
  level
  parent {
    id
    parent {
      id
    }
  }
}
    `;
export const IndustryTreeItemWithChildrenFragmentDoc = gql`
    fragment IndustryTreeItemWithChildren on Industry {
  ...IndustryTreeItem
  children {
    ...IndustryTreeItem
    children {
      ...IndustryTreeItem
    }
  }
}
    ${IndustryTreeItemFragmentDoc}`;
export const IndustryTreeDocument = gql`
    query IndustryTree {
  industries {
    tree {
      ...IndustryTreeItemWithChildren
    }
  }
}
    ${IndustryTreeItemWithChildrenFragmentDoc}`;

/**
 * __useIndustryTreeQuery__
 *
 * To run a query within a React component, call `useIndustryTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustryTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndustryTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndustryTreeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IndustryTreeQuery, IndustryTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IndustryTreeQuery, IndustryTreeQueryVariables>(IndustryTreeDocument, options);
      }
export function useIndustryTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IndustryTreeQuery, IndustryTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IndustryTreeQuery, IndustryTreeQueryVariables>(IndustryTreeDocument, options);
        }
// @ts-ignore
export function useIndustryTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IndustryTreeQuery, IndustryTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IndustryTreeQuery, IndustryTreeQueryVariables>;
export function useIndustryTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IndustryTreeQuery, IndustryTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IndustryTreeQuery | undefined, IndustryTreeQueryVariables>;
export function useIndustryTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IndustryTreeQuery, IndustryTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IndustryTreeQuery, IndustryTreeQueryVariables>(IndustryTreeDocument, options);
        }
export type IndustryTreeQueryHookResult = ReturnType<typeof useIndustryTreeQuery>;
export type IndustryTreeLazyQueryHookResult = ReturnType<typeof useIndustryTreeLazyQuery>;
export type IndustryTreeSuspenseQueryHookResult = ReturnType<typeof useIndustryTreeSuspenseQuery>;
export type IndustryTreeQueryResult = Apollo.QueryResult<IndustryTreeQuery, IndustryTreeQueryVariables>;